import { applyMiddleware, createStore } from 'redux';
import { Map } from 'immutable';
import { composeWithDevTools } from '@redux-devtools/extension';
import { sagaMiddleware } from './sagaMiddleware';
import { rootReducer } from './redux/rootReducer';
import { runSagas } from './redux/sagas';

const initialState = Map();

const middlewares = [sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
// eslint-disable-next-line global-require
  const { createLogger } = require('redux-logger');
  middlewares.push(createLogger({
    collapsed: true,
    stateTransformer: state => state.toJS(),
  }));
}

const storeEnhancer = composeWithDevTools(applyMiddleware(...middlewares));

export const store = createStore(rootReducer, initialState, storeEnhancer);

runSagas();
